import { CALL_ORIGIN_TARGETED_OFFERS, CODES_ALLOW_RETRY, EMAIL_ID, LOYALTY_ID } from 'contexts/CruiseSearchContext/constants';
import Cookies from 'js-cookie';
import Encrypt from 'lib/utilities/Encrypt';

const createCookies = async (loyaltyID, email, isEncrypt, config) => {
	const hadLoyaltyCookie = !!Cookies.get(LOYALTY_ID.cookie);
	const hadEmailCookie = !!Cookies.get(EMAIL_ID.cookie);

	if (loyaltyID && !hadLoyaltyCookie) {
		Cookies.set(LOYALTY_ID.cookie, loyaltyID, { domain: LOYALTY_ID.domain });
	}
	if (email && !hadEmailCookie) {
		let newEmail = email;
		if (!isEncrypt) {
			const response = await Encrypt(email, config);
			newEmail = response?.data?.cipher;
		}
		if (newEmail) Cookies.set(EMAIL_ID.cookie, newEmail, { domain: EMAIL_ID.domain });
	}
};

const removeCookies = async (originLoyalty, originEmail) => {
	if (originLoyalty === CALL_ORIGIN_TARGETED_OFFERS.COOKIE) {
		Cookies.remove(LOYALTY_ID.cookie);
	}

	if (originEmail === CALL_ORIGIN_TARGETED_OFFERS.COOKIE) {
		Cookies.remove(EMAIL_ID.cookie);
	}
};

export const validateErrorResponseTargetedOffers = async (data) => {
	const { networkError, loyaltyID, email, isEncrypt, errors, originLoyalty, originEmail, config } = data;
	const { extensions: { exception: { code = null } = {} } = {} } = errors?.[0] || {};
	const { extensions } = errors?.[0] || {};
	const isErr = () => (typeof code === 'string' ? code.startsWith('ERR_') : false);
	const isNetWork = () => !!networkError;
	const isNetWorkError =
		Object.values(CODES_ALLOW_RETRY).includes(code) || isNetWork() || Object.values(CODES_ALLOW_RETRY).includes(extensions?.code);
	const isValid = !isErr() && !isNetWorkError;

	if (isValid) {
		await createCookies(loyaltyID, email, isEncrypt, config);
	} else {
		await removeCookies(originLoyalty, originEmail);
	}

	return { code, isValid, isNetWorkError };
};
